import Box from "@mui/material/Box";
import { useFormikContext } from "formik";
import { AddClientFormValues } from "../../types";
import {
  Checkbox,
  Chip,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";
import { convertToSelectValue } from "./convertToSelectValue";

function ProductsSelect() {
  const context = useFormikContext<AddClientFormValues>();

  const handleProductRemoval = (label: string) => {
    return context.setFieldValue(
      "client-products",
      context.values["client-products"]?.filter(
        (selected) => selected !== label,
      ),
    );
  };

  return (
    <FormControl
      fullWidth
      sx={{ marginBottom: "2%", width: "100%", float: "right" }}
    >
      <InputLabel variant="standard" id="client-products-label">
        Products
      </InputLabel>
      <Select
        variant="standard"
        labelId="client-products-label"
        id="client-products"
        name="client-products"
        multiple
        value={convertToSelectValue(context.values["client-products"])}
        onChange={context.handleChange}
        renderValue={(selected) => (
          <Box
            sx={{ display: "flex", flexWrap: "wrap", padding: 0.5, gap: 0.5 }}
          >
            {selected.map((value) => (
              <Chip
                key={value}
                sx={{
                  fontWeight: 600,
                }}
                label={value}
                onDelete={() => handleProductRemoval(value)}
                deleteIcon={
                  <Cancel onMouseDown={(event) => event.stopPropagation()} />
                }
              />
            ))}
          </Box>
        )}
      >
        {[
          "Islands",
          "API",
          "Marketplace",
          "Badge",
          "Event",
          "Travel",
          "Logistics",
          "Product",
        ].map((product) => (
          <MenuItem key={product} value={product}>
            <Checkbox
              checked={context.values["client-products"]?.includes(product)}
            />
            <ListItemText primary={product} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default ProductsSelect;
